import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { Fragment } from "react";
import { SpotType } from "~/generated/graphql.types";
import { SpotForContentsEditFragment } from "~/routes/_shared/fragments.generated";
import { spotTypeJapanese } from "~/routes/_shared/utils";
import { useFetchCourseQuery } from "./index.generated";

const spotFacilitiesToJapanese = (spot: SpotForContentsEditFragment) => {
  const facilities = [];
  if (spot.hasRestaurant) {
    facilities.push("レストラン");
  }
  if (spot.hasCafe) {
    facilities.push("カフェ・軽食");
  }
  if (spot.hasRestroom) {
    facilities.push("トイレ");
  }
  if (spot.hasPaidParking) {
    facilities.push("有料駐車場");
  }
  if (spot.hasFreeParking) {
    facilities.push("無料駐車場");
  }
  return facilities
    .map((item, idx) => {
      return (
        <Fragment key={idx}>
          {item}
          <br />
        </Fragment>
      );
    })
    .slice(0, -1);
};

export const SpotsTableModal = ({ courseId }: { courseId: string }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [course] = useFetchCourseQuery({
    variables: {
      id: courseId,
    },
  });

  return (
    <>
      <Button onClick={onOpen} size="sm" variant="outline" rounded="full">
        スポット一覧
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={"7xl"}
        scrollBehavior="inside"
      >
        <ModalContent bgColor="gray.900" color="white">
          <ModalHeader>スポット一覧</ModalHeader>
          <ModalCloseButton />
          <ModalBody
            sx={{
              "&::-webkit-scrollbar": {
                width: 2,
                backgroundColor: "gray.900",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: `blue.400`,
              },
            }}
          >
            <TableContainer whiteSpace="unset">
              <Table variant="simple" size="sm">
                <Thead>
                  <Tr>
                    <Th>順序</Th>
                    <Th>スポット名</Th>
                    <Th>スポットタイプ</Th>
                    <Th>ディスクリプション</Th>
                    <Th>音声ガイド（原文）</Th>
                    <Th>施設</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {course.data?.course?.spots
                    .sort((a, b) => (a.order > b.order ? 1 : -1))
                    .filter((spot) => spot.spotType !== SpotType.RoutingGuide)
                    .map((spot, i) => (
                      <Tr key={i}>
                        <Td w={100}>{i + 1}</Td>
                        <Td w={100} lineHeight={6}>
                          {spot!.name}
                        </Td>
                        <Td w={100} lineHeight={6}>
                          {spotTypeJapanese.get(spot!.spotType)}
                        </Td>
                        <Td w={200} lineHeight={6}>
                          {spot!.description
                            ?.split("。")
                            .map((item, idx) => {
                              return (
                                <Fragment key={idx}>
                                  {item}。
                                  <br />
                                </Fragment>
                              );
                            })
                            .slice(0, -1)}
                        </Td>
                        <Td w={400} lineHeight={6}>
                          {spot!.narrationText
                            ?.split("。")
                            .map((item, idx) => {
                              return (
                                <Fragment key={idx}>
                                  {item}。
                                  <br />
                                </Fragment>
                              );
                            })
                            .slice(0, -1)}
                        </Td>

                        <Td w={50} lineHeight={6}>
                          {spotFacilitiesToJapanese(spot!)}
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              完了
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
